import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

const Logo = connect(null, { push })(
    ({ push }) => (
        <div className="logo" onClick={() => push('/')}>
            АРХКЛУБ LEGRAND
        </div>
    )
);

export default Logo;

export const LogoName = () => (
    <Link to="/">
        <img id="logo" src="/img/logo.png" alt="Legrand" />
    </Link>
);

export const LogoPromo = () => (
    <Fragment>
        <Logo />
        <div className="promo-title">
            Профессиональная программа для дизайнеров и архитекторов
        </div>
    </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/common/elements/Logo.js